import React from 'react';
import { FaqList } from '@components/FaqList';
import { ColoredBlockSection } from '@sections/shared/ColoredBlockSection';
import { Layout, Seo } from '@layout';
import {
  RegistryHeroSection,
  RegistryCashFreeGiftingSection,
  RegistryPublicCatalogSection,
  RegistryCross,
  UniversalRegistry,
  RegistryDreamStartHereSection,
  ChooseExperiencesSection,
} from '@sections/honeymoon-registry';

import { useTranslation } from 'react-i18next';

const page = 'honeymoon-registry';

const HoneyMoonRegistry = () => {
  const { t } = useTranslation();
  const seo = t('seo', { ns: 'honeymoonRegistry' });
  const faqQuestionsData = t('questions', { ns: 'faq' });

  return (
    <Layout
      transparentHeaderButtonVariant="defaultPrimeWeddingWebsites"
      isTransparentHeader={true}
      headerScrollThresholdVh={35}
      page={page}
    >
      <Seo
        title={seo.title}
        canonicalURL={'https://withjoy.com/honeymoon-registry/'}
        description={seo.content}
        ogImage={'common/meta_share/registry.jpg'}
      />
      <RegistryHeroSection />
      <RegistryCashFreeGiftingSection />
      <RegistryDreamStartHereSection />
      <ChooseExperiencesSection />
      <UniversalRegistry />
      <RegistryPublicCatalogSection />
      <RegistryCross />
      <ColoredBlockSection
        isLeftAligned
        backgroundColor="white"
        sideHeaderText={t('faq.title', { ns: 'honeymoonRegistry' })}
        sectionId="Honey_Moon_Registry_Design_FAQ"
        isToggleNeeded={true}
      >
        <FaqList accordion={true} questionNodes={[...faqQuestionsData.honeyMoonRegistry, ...faqQuestionsData.general]} color="neutra6" />
      </ColoredBlockSection>
    </Layout>
  );
};

export default HoneyMoonRegistry;
